(function () {
  if (window.__gxHomeBoot) return;
  window.__gxHomeBoot = true;

  /* Önce amiral gemisi kılıflar: Pro Max, sonra Pro. 18'den 14'e. */
  var CASE_PLAN = [
    { handle: "uyum-iphone-18-pro-max", gen: 18, tier: "pro-max" },
    { handle: "uyum-iphone-18-pro", gen: 18, tier: "pro" },
    { handle: "uyum-iphone-17-pro-max", gen: 17, tier: "pro-max" },
    { handle: "uyum-iphone-17-pro", gen: 17, tier: "pro" },
    { handle: "uyum-iphone-16-pro-max", gen: 16, tier: "pro-max" },
    { handle: "uyum-iphone-16-pro", gen: 16, tier: "pro" },
    { handle: "uyum-iphone-15-pro-max", gen: 15, tier: "pro-max" },
    { handle: "uyum-iphone-15-pro", gen: 15, tier: "pro" },
    { handle: "uyum-iphone-14-pro-max", gen: 14, tier: "pro-max" },
    { handle: "uyum-iphone-14-pro", gen: 14, tier: "pro" },
    { handle: "uyum-iphone-18-air", gen: 18, tier: "air" },
    { handle: "uyum-iphone-18", gen: 18, tier: "base" },
    { handle: "uyum-iphone-17-air", gen: 17, tier: "air" },
    { handle: "uyum-iphone-17", gen: 17, tier: "base" },
    { handle: "uyum-iphone-16-plus", gen: 16, tier: "plus" },
    { handle: "uyum-iphone-16", gen: 16, tier: "base" },
    { handle: "uyum-iphone-15-plus", gen: 15, tier: "plus" },
    { handle: "uyum-iphone-15", gen: 15, tier: "base" },
    { handle: "uyum-iphone-14-plus", gen: 14, tier: "plus" },
    { handle: "uyum-iphone-14", gen: 14, tier: "base" }
  ];

  function generation(text) {
    var nums = [];
    var re = /iPhone\s*(\d+)/gi;
    var match;
    while ((match = re.exec(text || ""))) nums.push(parseInt(match[1], 10));
    if (!nums.length) return 0;
    return Math.max.apply(null, nums);
  }

  function titleOf(el) {
    var link = el.querySelector("a[href*='/products/']");
    if (!link) return el.textContent || "";
    return link.getAttribute("aria-label") || link.textContent || "";
  }

  function isCase(title) {
    var text = String(title || "").toLowerCase();
    if (/temperli cam|ekran koruyucu|kordon|airpods|kulakl/.test(text)) return false;
    return /kılıf|kilif|kapak/.test(text);
  }

  function tierOf(title) {
    var text = " " + String(title || "").toLowerCase() + " ";
    if (/pro\s*max/.test(text)) return "pro-max";
    if (/\spro\s/.test(text)) return "pro";
    if (/\sair\s/.test(text)) return "air";
    if (/\splus\s/.test(text)) return "plus";
    return "base";
  }

  function productKey(el) {
    var node = el.getAttribute && el.getAttribute("data-product-id") ? el : el.querySelector("[data-product-id]");
    if (node) return node.getAttribute("data-product-id");
    var link = el.querySelector("a[href*='/products/']");
    if (!link) return "";
    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : href;
  }

  function bootInfinite(root) {
    if (root.dataset.gxBound) return;
    root.dataset.gxBound = "1";
    var section = root.closest(".shopify-section");
    if (!section) return;
    var first = section.querySelector(".resource-list__item");
    var list = first && first.parentElement;
    if (!list) return;

    if (section.querySelector(".gx-mobile-feed")) {
      bootModelFeed(root, section, list);
      return;
    }

    var page = parseInt(root.dataset.page || "1", 10);
    var pages = parseInt(root.dataset.pages || "1", 10);
    var loading = false;
    if (page >= pages) return;

    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      if (loading || page >= pages) return;
      loading = true;
      var next = page + 1;
      var sid = section.id.replace(/^shopify-section-/, "");
      fetch(location.pathname + "?section_id=" + encodeURIComponent(sid) + "&page=" + next, { credentials: "same-origin" })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var items = doc.querySelectorAll(".resource-list__item");
          var added = 0;
          items.forEach(function (item) {
            if (item.querySelector(".gx-rail-more")) return;
            list.appendChild(document.importNode(item, true));
            added += 1;
          });
          if (!added) page = pages;
          else {
            page = next;
            root.dataset.page = String(page);
          }
        })
        .catch(function () {})
        .finally(function () {
          loading = false;
          if (page >= pages) io.disconnect();
        });
    }, { rootMargin: "800px 0px" });

    io.observe(root);
  }

  /* Fareli geniş ekran: sonsuz kaydırma, footer sonu görünürken durur */
  var DESKTOP_MQ = window.matchMedia("(min-width: 750px) and (hover: hover) and (pointer: fine)");

  function bootModelFeed(root, section, list) {
    var desktop = DESKTOP_MQ.matches;

    var source = list.querySelector(".resource-list__item");
    if (!source) return;
    var template = source.cloneNode(true);
    /* Şablon kartın etiketi ve fiyatı ilk ürüne ait; her yeni kartta ürünün kendi verisinden yeniden kurulur.
       Etiketin biçimi (konum, köşe, yazı tipi) sunucunun yazdığı bir etiketten alınır. */
    var badgeProto = list.querySelector(".product-badges");
    badgeProto = badgeProto ? badgeProto.cloneNode(true) : null;

    var seen = {};
    list.querySelectorAll(".resource-list__item").forEach(function (item) {
      var title = titleOf(item);
      if (!(isCase(title) && generation(title) === 18 && tierOf(title) === "pro-max")) {
        item.remove();
        return;
      }
      var key = productKey(item);
      if (key) seen[key] = true;
    });

    var held = [];

    function columnCount() {
      var cols = window.getComputedStyle(list).gridTemplateColumns;
      var count = cols && cols !== "none" ? cols.split(" ").filter(Boolean).length : 0;
      if (count >= 1) return count;
      return desktop ? 4 : 2;
    }

    function realItems() {
      var items = [];
      list.querySelectorAll(":scope > .resource-list__item").forEach(function (item) {
        if (!item.classList.contains("gx-skel-row")) items.push(item);
      });
      return items;
    }

    var spare = realItems();
    var colsNow = columnCount();
    while (spare.length % colsNow !== 0) {
      held.unshift(spare.pop());
      held[0].remove();
    }

    /* products.json açıklamalarla birlikte geliyor: 250'lik sayfa megabaytları buluyordu; tampon en fazla 32 ürün */
    var PAGE_SIZE = 50;
    var planAt = 0;
    var jsonPage = 1;
    var rest = false;
    var buffer = [];
    var pending = [];
    var pendingShort = false;
    var fetching = false;
    var done = false;

    function makeSkel() {
      var el = document.createElement("div");
      el.className = "gx-skel";
      el.setAttribute("aria-hidden", "true");
      el.innerHTML = '<div class="gx-skel__card"><div class="gx-skel__img"></div><div class="gx-skel__line"></div><div class="gx-skel__line gx-skel__line--mid"></div><div class="gx-skel__line gx-skel__line--short"></div></div>';
      return el;
    }

    function stockSize() {
      return desktop ? columnCount() * 8 : 16;
    }

    function ensureSkel(rows) {
      var row = list.querySelector(".gx-skel-row");
      var cols = columnCount();
      var rowCount = rows == null ? (desktop ? 1 : 4) : rows;
      var slots = cols * rowCount;
      if (slots <= 0) {
        if (row) row.remove();
        return;
      }
      if (done && !buffer.length && !held.length) {
        if (row) row.remove();
        var more = section.querySelector(".gx-more");
        if (more) more.remove();
        return;
      }
      if (!row) {
        row = document.createElement("div");
        row.className = "resource-list__item gx-skel-row";
        list.appendChild(row);
      }
      row.style.setProperty("--gx-cols", String(cols));
      while (row.querySelectorAll(".gx-skel").length < slots) row.appendChild(makeSkel());
      while (row.querySelectorAll(".gx-skel").length > slots) row.removeChild(row.lastElementChild);
      if (row.parentElement === list) list.appendChild(row);
    }

    /* Kart ~170-340 px görünüyor; 600 px yüksek çözünürlüklü ekranlara da yetiyor (800 gereğinden ağırdı) */
    function sized(src) {
      if (!src) return "";
      return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=600";
    }

    function escAttr(text) {
      return String(text == null ? "" : text)
        .replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function imgUrl(src, width) {
      return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
    }

    /* Sunucunun yazdığı biçim: 2,699.00TL */
    function money(value) {
      return Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "TL";
    }

    /* snippets/price.liquid gibi: stoktaki ilk varyant, yoksa ilk varyant */
    function shownVariant(product) {
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i += 1) {
        if (variants[i].available) return variants[i];
      }
      return variants[0];
    }

    /* Fiyat alanı snippets/price.liquid ile aynı yapıda kurulur (indirimli fiyat önce, sonra üstü çizili fiyat ve yüzde) */
    function setPrice(node, product) {
      var box = node.querySelector("[ref='priceContainer']");
      var variant = shownVariant(product);
      if (!box || !variant) return;
      var price = Number(variant.price);
      var compare = Number(variant.compare_at_price || 0);
      if (compare > price) {
        var percent = Math.floor(((compare - price) * 100) / compare);
        box.innerHTML =
          '<span class="price-item__group price"><span class="visually-hidden">İndirimli fiyat&nbsp;</span>' + money(price) + "</span>" +
          '<span class="price-item__group price-item--regular compare-at-price"><span class="visually-hidden">Normal fiyat&nbsp;</span>' + money(compare) + "</span>" +
          (percent > 0 ? '<span class="price-item__group gx-indirim-yuzde">%' + percent + '<span class="visually-hidden">&nbsp;indirim</span></span>' : "");
      } else {
        box.innerHTML = '<span class="price">' + money(price) + "</span>";
      }
    }

    /* blocks/_product-card-gallery.liquid ile aynı kural: tükendiyse "Tükendi", üstü çizili fiyat varsa "İndirimde" */
    function setBadge(node, product) {
      node.querySelectorAll(".product-badges").forEach(function (el) { el.remove(); });
      var variants = product.variants || [];
      var soldOut = !variants.some(function (v) { return v.available; });
      var prices = [];
      var compares = [];
      variants.forEach(function (v) {
        prices.push(Number(v.price));
        if (v.compare_at_price) compares.push(Number(v.compare_at_price));
      });
      var onSale = compares.length > 0 && Math.min.apply(null, compares) > Math.min.apply(null, prices);
      if (!soldOut && !onSale) return;
      var gallery = node.querySelector(".card-gallery");
      if (!gallery) return;
      var badge;
      if (badgeProto) {
        badge = badgeProto.cloneNode(true);
      } else {
        badge = document.createElement("div");
        badge.className = "product-badges product-badges--top-right";
        badge.innerHTML = '<div class="product-badges__badge product-badges__badge--rectangle"></div>';
      }
      var label = badge.querySelector(".product-badges__badge");
      label.classList.remove("color-custom-badge-sale", "color-custom-badge-sold-out");
      label.classList.add(soldOut ? "color-custom-badge-sold-out" : "color-custom-badge-sale");
      label.textContent = soldOut ? "Tükendi" : "İndirimde";
      gallery.insertBefore(badge, gallery.querySelector(":scope > quick-add-component"));
    }

    /* Varyant kutucukları + hover görselleri: snippets/gx-card-variants.liquid ile aynı kurallar */
    function variantStrip(product, href) {
      var seen = {};
      var thumbs = [];
      var scrub = [];
      var count = 0;
      (product.variants || []).slice(0, 50).forEach(function (variant) {
        var image = variant.featured_image;
        if (!image || !image.src || seen[image.src]) return;
        seen[image.src] = true;
        if (count < 5) {
          var title = escAttr(variant.title);
          thumbs.push(
            '<a class="gx-cv__item' + (variant.available ? "" : " is-soldout") + '" href="' + href + "?variant=" + variant.id +
            '" data-src="' + escAttr(imgUrl(image.src, 640)) + '" title="' + title + '" aria-label="' + title + '">' +
            '<img class="gx-cv__img" src="' + escAttr(imgUrl(image.src, 96)) + '" alt="" width="48" height="48" loading="lazy"></a>'
          );
        }
        count += 1;
        if (scrub.length < 8) scrub.push(imgUrl(image.src, 640));
      });
      if (count < 2) return null;
      if (count > 5) {
        thumbs = thumbs.slice(0, 4);
        thumbs.push('<a class="gx-cv__more" href="' + href + '" aria-label="' + (count - 4) + ' renk daha">+' + (count - 4) + "</a>");
      }
      var strip = document.createElement("div");
      strip.className = "gx-cv";
      strip.setAttribute("data-imgs", JSON.stringify(scrub));
      strip.innerHTML = thumbs.join("");
      return strip;
    }

    function render(product) {
      var node = template.cloneNode(true);
      var id = String(product.id);
      var href = "/products/" + product.handle;
      /* Şablon kartın varyant şeridi başka ürüne ait: kaldır, aşağıda bu ürününkini kur */
      node.querySelectorAll(".gx-cv, .gx-cv-layer").forEach(function (el) { el.remove(); });
      node.classList.add("gx-drop");
      node.removeAttribute("id");
      node.querySelectorAll("[id]").forEach(function (el) { el.removeAttribute("id"); });
      node.querySelectorAll("[data-product-id]").forEach(function (el) {
        el.setAttribute("data-product-id", id);
      });
      node.querySelectorAll("a[href*='/products/']").forEach(function (link) {
        link.setAttribute("href", href);
        if (link.hasAttribute("aria-label")) link.setAttribute("aria-label", product.title);
      });
      var heading = node.querySelector("h3");
      if (heading) heading.textContent = product.title;
      node.querySelectorAll("p").forEach(function (paragraph) {
        if ((paragraph.textContent || "").trim().length > 24) paragraph.textContent = product.title;
      });
      setPrice(node, product);
      setBadge(node, product);
      var quick = node.querySelector("quick-add-component");
      if (quick) {
        quick.setAttribute("data-product-id", id);
        quick.setAttribute("data-product-title", product.title);
        if (product.options) quick.setAttribute("data-product-options-count", String(product.options.length));
      }
      var images = product.images || [];
      node.querySelectorAll("picture source").forEach(function (source) {
        source.remove();
      });
      var slides = node.querySelectorAll("slideshow-slide");
      for (var slideIndex = slides.length - 1; slideIndex >= 1; slideIndex -= 1) slides[slideIndex].remove();
      node.querySelectorAll("img").forEach(function (img, index) {
        var image = images[index];
        if (!image) {
          img.remove();
          return;
        }
        var fresh = document.createElement("img");
        fresh.className = img.className;
        fresh.alt = product.title;
        fresh.loading = "lazy";
        fresh.decoding = "async";
        fresh.src = sized(image.src);
        img.replaceWith(fresh);
      });
      var strip = variantStrip(product, href);
      var content = node.querySelector(".product-card__content");
      if (strip && content) content.appendChild(strip);
      return node;
    }

    function matches(product) {
      if (!product || seen[String(product.id)]) return false;
      if (rest) return true;
      var phase = CASE_PLAN[planAt];
      if (!phase || !isCase(product.title)) return false;
      if (generation(product.title) !== phase.gen) return false;
      return tierOf(product.title) === phase.tier;
    }

    function advance() {
      jsonPage = 1;
      if (!rest) {
        planAt += 1;
        if (planAt >= CASE_PLAN.length) rest = true;
        return;
      }
      done = true;
    }

    /* Footer'ın en altı ekrandaysa müşteri sona inmek istiyor: yükleme dursun */
    function footerEndVisible() {
      var footers = document.querySelectorAll("footer, .shopify-section-group-footer-group");
      var last = footers[footers.length - 1];
      if (!last) return false;
      var rect = last.getBoundingClientRect();
      return rect.height > 0 && rect.bottom <= window.innerHeight + 4;
    }

    function setPaused(paused) {
      var row = list.querySelector(".gx-skel-row");
      if (row) row.style.display = paused ? "none" : "";
    }

    function skelVisible() {
      if (desktop) {
        if (footerEndVisible()) {
          setPaused(true);
          return false;
        }
        setPaused(false);
        var end = list.getBoundingClientRect();
        if (end.bottom > window.innerHeight + 400) return false;
      }
      var row = list.querySelector(".gx-skel-row");
      if (!row) return false;
      var rect = row.getBoundingClientRect();
      return rect.bottom > 24 && rect.top < window.innerHeight + 160;
    }

    function readyCount() {
      return buffer.length + held.length;
    }

    function placeOneRow(withSkel) {
      var cols = columnCount();
      if (readyCount() < cols) return false;
      if (withSkel !== false) ensureSkel();
      var row = list.querySelector(".gx-skel-row");
      var batch = [];
      while (batch.length < cols && held.length) batch.push(held.shift());
      while (batch.length < cols && buffer.length) batch.push(render(buffer.shift()));
      batch.forEach(function (card) {
        card.classList.add("gx-drop");
        if (row) list.insertBefore(card, row);
        else list.appendChild(card);
      });
      if (row) list.appendChild(row);
      return true;
    }

    function rowsPerScroll() {
      var card = list.querySelector(":scope > .resource-list__item:not(.gx-skel-row)");
      var height = card ? card.getBoundingClientRect().height : 420;
      if (height < 80) height = 420;
      return Math.max(2, Math.ceil(window.innerHeight / (height + 24)));
    }

    var dropping = false;

    function drop() {
      if (done && readyCount() === 0) {
        ensureSkel();
        io.disconnect();
        return;
      }
      if (done && readyCount() < columnCount()) {
        ensureSkel();
        var row = list.querySelector(".gx-skel-row");
        while (held.length) {
          var leftover = held.shift();
          if (row) list.insertBefore(leftover, row);
        }
        while (buffer.length) {
          var lastCard = render(buffer.shift());
          if (row) list.insertBefore(lastCard, row);
        }
        ensureSkel();
        io.disconnect();
        return;
      }
      if (dropping || !skelVisible()) return;
      var burst = desktop ? 1 : 4;
      if (readyCount() < columnCount() * (done ? 1 : burst)) {
        pull();
        return;
      }
      dropping = true;
      setTimeout(function () {
        var placed = 0;
        while (placed < burst && readyCount() >= columnCount()) {
          if (!placeOneRow()) break;
          placed += 1;
        }
        dropping = false;
        if (skelVisible() && readyCount() >= columnCount()) setTimeout(drop, desktop ? 60 : 420);
        else pull();
      }, desktop ? 160 : 220);
    }

    function takePending() {
      while (pending.length && buffer.length < stockSize()) {
        var product = pending.shift();
        if (!matches(product)) continue;
        seen[String(product.id)] = true;
        buffer.push(product);
      }
      if (pending.length) return;
      if (!pendingShort) {
        jsonPage += 1;
        return;
      }
      pendingShort = false;
      advance();
    }

    function pull() {
      if (fetching || done || buffer.length >= stockSize()) return;
      if (pending.length) {
        takePending();
        drop();
        if (!done && buffer.length < stockSize()) pull();
        return;
      }
      fetching = true;
      var handle = rest ? "all" : CASE_PLAN[planAt].handle;
      fetch("/collections/" + handle + "/products.json?limit=" + PAGE_SIZE + "&page=" + jsonPage, { credentials: "same-origin" })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          pending = products;
          pendingShort = products.length < PAGE_SIZE;
          fetching = false;
          takePending();
          if (!done && buffer.length < stockSize() && !pending.length) pull();
          drop();
        })
        .catch(function () {
          fetching = false;
          setTimeout(pull, 800);
        });
    }

    function clearSkel() {
      var row = list.querySelector(".gx-skel-row");
      if (row) row.remove();
    }

    /* Masaüstü: ilk açılışta 6 satır iskeletle dolar, sonra sonsuz kaydırma */
    var INITIAL_ROWS = 6;
    var MIN_SKEL_MS = 350;

    function takeRow() {
      var cols = columnCount();
      var batch = [];
      while (batch.length < cols && held.length) batch.push(held.shift());
      while (batch.length < cols && buffer.length) batch.push(render(buffer.shift()));
      return batch;
    }

    /* Kart görselleri inene kadar iskelet kalsın (en fazla 1.5 sn) */
    function preload(cards) {
      var waits = [];
      cards.forEach(function (card) {
        var img = card.querySelector("img");
        var src = img && (img.currentSrc || img.src);
        if (!src || img.complete) return;
        waits.push(new Promise(function (resolve) {
          var probe = new Image();
          probe.onload = probe.onerror = resolve;
          probe.src = src;
        }));
      });
      return Promise.race([
        Promise.all(waits),
        new Promise(function (resolve) { setTimeout(resolve, 1500); })
      ]);
    }

    /* İskelet satırları hemen görünür, ürünler satır satır yerine geçer */
    function fillRows(target, onDone) {
      var placed = 0;
      var startedAt = Date.now();
      ensureSkel(target);
      function step() {
        if (placed >= target || (done && readyCount() < columnCount())) {
          onDone();
          return;
        }
        if (readyCount() < columnCount()) {
          pull();
          setTimeout(step, 150);
          return;
        }
        var batch = takeRow();
        preload(batch).then(function () {
          var wait = Math.max(0, MIN_SKEL_MS - (Date.now() - startedAt));
          setTimeout(function () {
            var row = list.querySelector(".gx-skel-row");
            batch.forEach(function (card) {
              card.classList.add("gx-drop");
              if (row) list.insertBefore(card, row);
              else list.appendChild(card);
            });
            placed += 1;
            ensureSkel(target - placed);
            if (readyCount() < columnCount() * 2) pull();
            setTimeout(step, 90);
          }, wait);
        });
      }
      step();
    }

    function afterFill() {
      clearSkel();
      if (done && readyCount() < columnCount()) {
        while (held.length || buffer.length) {
          list.appendChild(held.length ? held.shift() : render(buffer.shift()));
        }
        var more = section.querySelector(".gx-more");
        if (more) more.remove();
        return;
      }
      showMore();
    }

    /* Masaüstü ilk satırlar dolduktan sonra sonsuz kaydırmaya geçer */
    function showMore() {
      var more = section.querySelector(".gx-more");
      if (more) more.remove();
      if (done && readyCount() === 0) {
        clearSkel();
        return;
      }
      ensureSkel();
      var row = list.querySelector(".gx-skel-row");
      if (row && io) io.observe(row);
      drop();
    }

    /* İlk ürün çekimi sayfa açılışıyla yarışmasın: tarayıcı boşa çıkınca (en geç 2,5 sn) başlar */
    function whenIdle(fn) {
      if ("requestIdleCallback" in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 1200);
    }

    if (!desktop) ensureSkel();
    whenIdle(function () {
      pull();
      if (desktop) {
        var missingRows = INITIAL_ROWS - Math.floor(realItems().length / colsNow);
        if (missingRows > 0) fillRows(missingRows, afterFill);
        else showMore();
      }
    });

    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) drop();
    }, { rootMargin: "200px 0px" });
    io.observe(root);
    var skelRow = list.querySelector(".gx-skel-row");
    if (skelRow) io.observe(skelRow);
    var scrollQueued = false;
    /* Masaüstünde sayfa .page-wrapper içinde kayar: capture ile her kaydırmayı yakala.
       Her karede değil 150 ms'de bir bakılır; her karede sayfa ölçmek kaydırmayı takılttırıyordu */
    document.addEventListener("scroll", function () {
      if (scrollQueued) return;
      scrollQueued = true;
      setTimeout(function () {
        scrollQueued = false;
        drop();
      }, 150);
    }, { passive: true, capture: true });

    /* Pencere boyutu / cihaz yönü değişirse footer kuralını aç/kapat */
    DESKTOP_MQ.addEventListener("change", function () {
      if (DESKTOP_MQ.matches === desktop) return;
      desktop = DESKTOP_MQ.matches;
      setPaused(false);
      ensureSkel();
      var row = list.querySelector(".gx-skel-row");
      if (row) io.observe(row);
      drop();
    });
  }


  function boot() {
    document.querySelectorAll("[data-gordonix-infinite]").forEach(bootInfinite);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
